module.exports = __webpack_public_path__ + "img/still (20).f94610f4.jpg";